import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { DialogProvider } from './contexts/DialogContext';
import PrivateRoute from './components/PrivateRoute';
import './App.css';

// Componentes
import Navbar from './components/Navbar';
import StockCounter from './components/StockCounter';

// Páginas
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Productos from './pages/Productos';
import Presupuestos from './pages/Presupuestos';
import Pedidos from './pages/Pedidos';
import PanelControl from './pages/PanelControl';

function App() {
  return (
    <Router>
      <AuthProvider>
        <DialogProvider>
        <div className="App">
          <Navbar />
          
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
              <Route path="/clientes" element={<PrivateRoute><Clientes /></PrivateRoute>} />
              <Route path="/productos" element={<PrivateRoute><Productos /></PrivateRoute>} />
              <Route path="/presupuestos" element={<PrivateRoute><Presupuestos /></PrivateRoute>} />
              <Route path="/pedidos" element={<PrivateRoute><Pedidos /></PrivateRoute>} />
              <Route path="/panel-control" element={<PrivateRoute><PanelControl /></PrivateRoute>} />
            </Routes>
          </main>
        </div>
        <StockCounter />
        </DialogProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;